export const EN = {
    "LOADING_LOCATIONS": "Loading Locations...",
    "LOADING_CHARACTERS": "Loading Characters...",
    "LOADING": "Loading...",
    "ROTATE_CAMERA": "Camera Angle %1",
    "SET_LABEL": "Set label %1",
    "REMOVE_LABEL": "Remove label",
    "TOOLTIP_ROTATE_CAMERA": "Rotate camera (0° is front)",
    "TOOLTIP_SET_LABEL": "Put a label in the corner of following messages",
    "TOOLTIP_REMOVE_LABEL": "Remove label from messages",
    "TOOLTIP_SHOW_MENU": "Show a multiple choice menu and store the answer. Retrive the answer using Get answer block",
    "SHOW_MENU_0": "Show Menu %1",
    "SHOW_MENU_1": "Options %1",
    "GET_ANSWER": "Get answer",
    "TOOLTIP_GET_ANSWER": "Return last given answer",
    "ASKS": "Ask %1 and wait",
    "TOOLTIP_ASKS": "Ask something and wait for confirmation",
    "SHOW": "Show %1 %2",
    "SHOW_STUFF": "Show %1",
    "TOOLTIP_SHOW": "Show a character",
    "SHOW_LOCATION": "Show Location %1",
    "TOOLTIP_SHOW_LOCATION": "Set your scene in a specific location",
    "SAYS": "Say %1",
    "TOOLTIP_SAYS": "Show a message",
    "SAYS_FOR_SECONDS": "Say %1 for %2 seconds",
    "TOOLTIP_SAYS_FOR_SECONDS": "Show a message for a specific amount of time",
    "GET_CHARACTER": "%1",
    "TOOLTIP_GET_CHARACTER": "Choose a character",
    "GET_LOCATION": "%1",
    "TOOLTIP_GET_LOCATION": "Choose a location",
    "WAIT_SECONDS": "Wait %1",
    "TOOLTIP_WAIT_SECONDS": "Wait before continue to execute your code",
    "CLEAR": "Clear your scene",
    "TOOLTIP_CLEAR": "Remove any location or character",
    "HIDE": "Hide current message",
    "TOOLTIP_HIDE": "Remove any message from the screen",
    "SHADOW_QUESTION": "Question",
    "SHADOW_OPTION_1": "Option 1",
    "SHADOW_OPTION_2": "Option 2",
    "SHOW_EMOTION": "Emoji %1",
    "TOOLTIP_SHOW_EMOTION": "Emoji",
    "HIDE_EMOTION": "Hide emotion",
    "TOOLTIP_HIDE_EMOTION": "No emotion shown",
    "GET_EMOTION": "%1",
    "TOOLTIP_GET_EMOTION": "No emotion shown",
    "IDLE": "Idle",
    "VICTORY": "Victory",
    "RUN": "Run",
    "WALK": "Walk",
    "DEFEAT": "Defeat",
    "JUMP": "Jump",
    "DEATH": "Death",
    "PUNCH": "Punch",
    "RECEIVEHIT": "Receive Hit"
}

export const FR = {
    "LOADING_LOCATIONS": "Chargement des lieux...",
    "LOADING_CHARACTERS": "Chargement des personnages...",
    "LOADING": "Chargement...",
    "ROTATE_CAMERA": "Angle de la caméra %1",
    "SET_LABEL": "Définir l'étiquette %1",
    "REMOVE_LABEL": "Retirer l'étiquette",
    "TOOLTIP_ROTATE_CAMERA": "Faire pivoter la caméra (0° pour l'avant)",
    "TOOLTIP_SET_LABEL": "Mettez une étiquette dans le coin des messages suivants",
    "TOOLTIP_REMOVE_LABEL": "Enlever l'étiquette des messages",
    "TOOLTIP_SHOW_MENU": "Afficher un menu à choix multiples et enregistrer la réponse. Récupérer la réponse en utilisant le bloc Get answer",
    "SHOW_MENU_0": "Afficher le menu %1",
    "SHOW_MENU_1": "Options %1",
    "GET_ANSWER": "Obtenir une réponse",
    "TOOLTIP_GET_ANSWER": "Retour à la dernière réponse donnée",
    "ASKS": "Demandez %1 et attendez",
    "TOOLTIP_ASKS": "Demandez quelque chose et attendez la confirmation",
    "SHOW": "Afficher %1 %2",
    "SHOW_STUFF": "Afficher %1",
    "TOOLTIP_SHOW": "Montrer un personnage",
    "SHOW_LOCATION": "Afficher le lieu %1",
    "TOOLTIP_SHOW_LOCATION": "Placer votre scène dans un lieu spécifique",
    "SAYS": "Dire %1",
    "TOOLTIP_SAYS": "Afficher un message",
    "SAYS_FOR_SECONDS": "Dire %1 pendant %2 secondes",
    "TOOLTIP_SAYS_FOR_SECONDS": "Afficher un message pendant un laps de temps déterminé",
    "GET_CHARACTER": "%1",
    "TOOLTIP_GET_CHARACTER": "Choisir un personnage",
    "GET_OBJECT": "%1",
    "TOOLTIP_GET_OBJECT": "Choisir un objet",
    "GET_LOCATION": "%1",
    "TOOLTIP_GET_LOCATION": "Choisir un lieu",
    "WAIT_SECONDS": "Attendez %1",
    "TOOLTIP_WAIT_SECONDS": "Attendez avant de poursuivre l'exécution de votre code",
    "CLEAR": "Effacer la scène",
    "TOOLTIP_CLEAR": "Supprimer tou lieu ou personnage",
    "HIDE": "Cacher le message actuel",
    "TOOLTIP_HIDE": "Supprimer tout message de l'écran",
    "SHADOW_QUESTION": "Question",
    "SHADOW_OPTION_1": "Option 1",
    "SHADOW_OPTION_2": "Option 2",
    "SHOW_EMOTION": "Émoji %1",
    "TOOLTIP_SHOW_EMOTION": "Émoji",
    "HIDE_EMOTION": "Hide emotion",
    "TOOLTIP_HIDE_EMOTION": "No emotion shown",
    "GET_EMOTION": "%1",
    "TOOLTIP_GET_EMOTION": "Émoji",
    "IDLE": "Idle",
    "VICTORY": "Victory",
    "RUN": "Run",
    "WALK": "Walk",
    "DEFEAT": "Defeat",
    "JUMP": "Jump",
    "DEATH": "Death",
    "PUNCH": "Punch",
    "RECEIVEHIT": "Receive Hit"
}

const LT = {
    "LOADING_LOCATIONS": "Įkeliamos vietos....",
    "LOADING_CHARACTERS": "Įkeliami simboliai...",
    "LOADING": "Įkeliama...",
    "ROTATE_CAMERA": "Kameros kampas %1",
    "SET_LABEL": "Nustatyti etiketę %1",
    "REMOVE_LABEL": "Panaikinti etiketę",
    "TOOLTIP_ROTATE_CAMERA": "Pasukti kamerą (0° yra priekyje)",
    "TOOLTIP_SET_LABEL": "Įdėkite etiketę šių pranešimų kampe",
    "TOOLTIP_REMOVE_LABEL": "Pašalinti etiketę iš pranešimų",
    "TOOLTIP_SHOW_MENU": "Parodykite kelių pasirinkimų meniu ir išsaugokite atsakymą. Gaukite atsakymą naudodami atsakymo bloką 'Gauti atsakymą'",
    "SHOW_MENU_0": "Rodyti menu %1",
    "SHOW_MENU_1": "Parinktys %1",
    "GET_ANSWER": "Get answer",
    "TOOLTIP_GET_ANSWER": "Grąžinti paskutinį pateiktą atsakymą",
    "ASKS": "Prašykite %1 ir laukite",
    "TOOLTIP_ASKS": "Paklauskite ko nors ir laukite patvirtinimo",
    "SHOW": "Rodyti %1 %2",
    "SHOW_STUFF": "Rodyti %1",
    "SHOW_EMOTION": "Rodyti %1",
    "TOOLTIP_SHOW": "Rodyti simbolį",
    "SHOW_LOCATION": "Rodyti vietovę %1",
    "TOOLTIP_SHOW_LOCATION": "Nustatykite sceną tam tikroje vietoje",
    "SAYS": "Sako %1",
    "TOOLTIP_SAYS": "Rodyti pranešimą",
    "SAYS_FOR_SECONDS": "Sakyti %1 - %2 sekundes",
    "TOOLTIP_SAYS_FOR_SECONDS": "Rodyti pranešimą tam tikrą laiką",
    "GET_CHARACTER": "%1",
    "TOOLTIP_GET_CHARACTER": "Pasirinkti simbolį",
    "GET_OBJECT": "%1",
    "TOOLTIP_GET_OBJECT": "Pasirinkti objektą",
    "GET_LOCATION": "%1",
    "TOOLTIP_GET_LOCATION": "Pasirinkti vietovę",
    "WAIT_SECONDS": "Laukti %1",
    "TOOLTIP_WAIT_SECONDS": "Palaukite prieš tęsdami kodo vykdymą",
    "CLEAR": "Išvalykite sceną",
    "TOOLTIP_CLEAR": "Pašalinti bet kurią vietą ar simbolį",
    "HIDE": "Paslėpti dabartinį pranešimą",
    "TOOLTIP_HIDE": "Pašalinti bet kokį pranešimą iš ekrano",
    "SHADOW_QUESTION": "Klausimas",
    "SHADOW_OPTION_1": "1 parinktis",
    "SHADOW_OPTION_2": "2 parinktis",
    "SHOW_EMOTION": "Emoji %1",
    "TOOLTIP_SHOW_EMOTION": "Emoji",
    "HIDE_EMOTION": "Hide emotion",
    "TOOLTIP_HIDE_EMOTION": "No emotion shown",
    "GET_EMOTION": "%1",
    "TOOLTIP_GET_EMOTION": "No emotion shown",
    "IDLE": "Idle",
    "VICTORY": "Victory",
    "RUN": "Run",
    "WALK": "Walk",
    "DEFEAT": "Defeat",
    "JUMP": "Jump",
    "DEATH": "Death",
    "PUNCH": "Punch",
    "RECEIVEHIT": "Receive Hit"
}

export const DE = {
    "LOADING_LOCATIONS": "Lade Standorte...",
    "LOADING_CHARACTERS": "Lade Zeichen...",
    "LOADING": "Lade...",
    "ROTATE_CAMERA": "Kamerawinkel %1",
    "SET_LABEL": "Stelle Beschriftung ein %1",
    "REMOVE_LABEL": "Entferne Beschriftung",
    "TOOLTIP_ROTATE_CAMERA": "Drehe Kamera (0° ist Vorne)",
    "TOOLTIP_SET_LABEL": "Setze Beschriftung in die Ecke der folgenden Meldungen",
    "TOOLTIP_REMOVE_LABEL": "Entferne Überschrift von Nachrichten",
    "TOOLTIP_SHOW_MENU": "Zeige Multiple-Choice-Menü und speichere die Antwort. Abruf der Antwort mit Antwort erhalten Befehl",
    "SHOW_MENU_0": "Zeige Menü %1",
    "SHOW_MENU_1": "Optionen %1",
    "GET_ANSWER": "Antwort erhalten",
    "TOOLTIP_GET_ANSWER": "Letzte gegebene Antwort rückgängig machen",
    "ASKS": "Frage %1 und warte",
    "TOOLTIP_ASKS": "Frage etwas und warte auf Bestätigung",
    "SHOW": "Zeige %1 %2",
    "SHOW_STUFF": "Zeige %1",
    "TOOLTIP_SHOW": "Zeige einen Charakter",
    "SHOW_LOCATION": "Zeige Standort %1",
    "TOOLTIP_SHOW_LOCATION": "Setzen Sie Ihre Szene an einen bestimmten Ort",
    "SAYS": "Sage %1",
    "TOOLTIP_SAYS": "Zeige eine Nachricht",
    "SAYS_FOR_SECONDS": "Sage %1 für %2 Sekunden",
    "TOOLTIP_SAYS_FOR_SECONDS": "Zeige eine Nachricht für eine bestimmte Zeitdauer",
    "GET_CHARACTER": "%1",
    "TOOLTIP_GET_CHARACTER": "Wähle einen Charakter",
    "GET_OBJECT": "%1",
    "TOOLTIP_GET_OBJECT": "Wähle ein Objekt",
    "GET_LOCATION": "%1",
    "TOOLTIP_GET_LOCATION": "Wähle einen Ort",
    "WAIT_SECONDS": "Warte %1",
    "TOOLTIP_WAIT_SECONDS": "Warte: bevor du mit der Programmausführung fortfährst",
    "CLEAR": "Lösche die Szene",
    "TOOLTIP_CLEAR": "Entferne alle Orte oder Charakter",
    "HIDE": "Verberge aktuelle Nachricht",
    "TOOLTIP_HIDE": "Entferne alle Nachrichten vom Bildschirm",
    "SHADOW_QUESTION": "Frage",
    "SHADOW_OPTION_1": "Option 1",
    "SHADOW_OPTION_2": "Option 2",
    "SHOW_EMOTION": "Emoji %1",
    "TOOLTIP_SHOW_EMOTION": "Emoji",
    "HIDE_EMOTION": "Hide emotion",
    "TOOLTIP_HIDE_EMOTION": "No emotion shown",
    "GET_EMOTION": "%1",
    "TOOLTIP_GET_EMOTION": "No emotion shown",
    "IDLE": "Idle",
    "VICTORY": "Victory",
    "RUN": "Run",
    "WALK": "Walk",
    "DEFEAT": "Defeat",
    "JUMP": "Jump",
    "DEATH": "Death",
    "PUNCH": "Punch",
    "RECEIVEHIT": "Receive Hit"
}

export const IT = {
    "LOADING_LOCATIONS": "Caricamento Luoghi...",
    "LOADING_CHARACTERS": "Caricamento Personaggi...",
    "LOADING": "Caricamento...",
    "ROTATE_CAMERA": "Angolazione camera %1",
    "SET_LABEL": "Imposta un etichetta %1",
    "REMOVE_LABEL": "Rimuovi etichetta",
    "TOOLTIP_ROTATE_CAMERA": "Ruota la camera (a 0° è di fronte)",
    "TOOLTIP_SET_LABEL": "Metti un'etichetta nell'angolo dei seguenti messaggi",
    "TOOLTIP_REMOVE_LABEL": "Rimuovi l'etichetta dai messaggi ",
    "TOOLTIP_SHOW_MENU": "Mostra un menu a scelta multipla e memorizza la risposta. Riprova la risposta usando il blocco Ottieni risposta",
    "SHOW_MENU_0": "Mostra Menu %1",
    "SHOW_MENU_1": "Opzioni %1",
    "GET_ANSWER": "Ricevi una risposta",
    "TOOLTIP_GET_ANSWER": "Resituiscimi l'ultima risposta data",
    "ASKS": "Chiedi %1 e aspetta",
    "TOOLTIP_ASKS": "Chiedi qualsiasi cosa e aspetta per una risposta",
    "SHOW": "Mostra %1 %2",
    "SHOW_STUFF": "Mostra %1",
    "TOOLTIP_SHOW": "Mostra un personaggio",
    "SHOW_LOCATION": "Mostra ambientazione %1",
    "TOOLTIP_SHOW_LOCATION": "Imposta la tua scena in una specifica ambientazione",
    "SAYS": "Dire %1",
    "TOOLTIP_SAYS": "Mostra un messaggio",
    "SAYS_FOR_SECONDS": "Dire %1 per %2 secondi",
    "TOOLTIP_SAYS_FOR_SECONDS": "Mostra un messaggio per il tempo richiesto",
    "GET_CHARACTER": "%1",
    "TOOLTIP_GET_CHARACTER": "Scegli un personaggio",
    "GET_LOCATION": "%1",
    "TOOLTIP_GET_LOCATION": "Scegli ambientazione",
    "WAIT_SECONDS": "Aspetta %1",
    "TOOLTIP_WAIT_SECONDS": "Aspetta il tempo desiderato prima di continuare ad eseguire il codice",
    "CLEAR": "Pulisci la scena",
    "TOOLTIP_CLEAR": "Rimuove ogni ambientazione e personaggio",
    "HIDE": "Nascondi il messaggio corrente",
    "TOOLTIP_HIDE": "Rimuovi qualsiasi messaggio dallo schermo",
    "SHADOW_QUESTION": "Domanda",
    "SHADOW_OPTION_1": "Opzione 1",
    "SHADOW_OPTION_2": "Opzione 2",
    "SHOW_EMOTION": "Stato d'animo %1",
    "TOOLTIP_SHOW_EMOTION": "Esprimi uno stato emotivo",
    "HIDE_EMOTION": "Nascondi stato emotivo",
    "TOOLTIP_HIDE_EMOTION": "Nessuno stato emotivo verrà mostrato",
    "GET_EMOTION": "%1",
    "TOOLTIP_GET_EMOTION": "Richiedi l'emozione corrente",
    "IDLE": "Idle",
    "VICTORY": "Victory",
    "RUN": "Run",
    "WALK": "Walk",
    "DEFEAT": "Defeat",
    "JUMP": "Jump",
    "DEATH": "Death",
    "PUNCH": "Punch",
    "RECEIVEHIT": "Receive Hit"
}

var currentLocale = FR;
var currentLang = 'fr';

export function getMsg(msg) {
    return currentLocale[msg] ? currentLocale[msg] : msg;
}

export function getLocale() {
    return currentLang;
}

export function setLocale(langCode) {
    if (langCode === 'en') {
        currentLang = 'en';
        currentLocale = EN;
    } else if (langCode === 'fr') {
        currentLang = 'fr';
        currentLocale = FR;
    } else if (langCode === 'lt') {
        currentLang = 'lt';
        currentLocale = LT;
    } else if (langCode === 'it') {
        currentLang = 'it';
        currentLocale = IT;
    } else if (langCode === 'de') {
        currentLang = 'de';
        currentLocale = DE;
    }
}

